import { render, staticRenderFns } from "./memberData.vue?vue&type=template&id=13807c47&scoped=true&"
import script from "./memberData.vue?vue&type=script&lang=js&"
export * from "./memberData.vue?vue&type=script&lang=js&"
import style0 from "./memberData.vue?vue&type=style&index=0&id=13807c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13807c47",
  null
  
)

export default component.exports